import { render, staticRenderFns } from "./GModalBase.vue?vue&type=template&id=4118adb4&scoped=true&"
import script from "./GModalBase.vue?vue&type=script&lang=ts&"
export * from "./GModalBase.vue?vue&type=script&lang=ts&"
import style0 from "./GModalBase.vue?vue&type=style&index=0&id=4118adb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4118adb4",
  null
  
)

export default component.exports